import * as moment from 'moment';
import * as React from 'react';
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { checkUncheck as checkUncheckAction, selectMessage as selectMessageAction } from "../../actions/mailActions";
import UserSettings from '../settings/model/Settings';
import Message from './model/Message';

interface IMessageItemProps {
  message: Message;
  selectedMessage: Message;
  messageList: Message[];
  settings: UserSettings;
  selectMessage: (messages: Message) => any;
  checkUncheck: (messages: Message[]) => any;
}

interface IMessageItemState {
  selected: boolean;
}

export class MessageItem extends React.Component<IMessageItemProps, IMessageItemState> {

  constructor(props: IMessageItemProps) {
    super(props);
    this.state = { selected: false };
    this.selectEmail = this.selectEmail.bind(this);
    this.checkboxHandler = this.checkboxHandler.bind(this);
  }

  public selectEmail() {
    const { message, selectMessage } = this.props;
    if (message) {
      selectMessage(message);
    }
  }

  public checkboxHandler() {
    const selectedMessages = this.props.messageList.map((m) => {
      return { ...m, selected: m.id === this.props.message.id ? !m.selected : m.selected };
    })
    this.props.checkUncheck(selectedMessages);
  }

  public render() {
    const { message, selectedMessage, settings } = this.props;
    const dateFormat = settings.dateFormat ? settings.dateFormat.toUpperCase() + ' hh:mm A' : 'MM/DD/YYYY hh:mm A';
    const hasSelectedMessages = this.props.messageList.filter((m) => m.selected).length > 0;
    if (!message) {
      return null;
    }

    let returnPath = message.headers['return-path'] || "";
    returnPath = returnPath.replace(/<|>/g,'')

    return (
      <tr className={"desktop email-item row " + (selectedMessage.id === message.id && !hasSelectedMessages ? 'selected ' : '') + (message.readStatus === 'unread' ? 'unread ' : '')} key={message.id} onClick={this.selectEmail}>
        <td className="col-sm-1 check" scope="row">
          <input type="checkbox" checked={message.selected || false} onChange={this.checkboxHandler} />
        </td>
        <td className="text from col-sm-2">
          <span className="normal" title={returnPath}>{message.headers.from || returnPath}</span>
        </td>
        <td className="text to col-sm-2">
          <span className="normal" title={message.headers['x-orig-to']}>{message.headers.to || message.headers['x-orig-to']}</span>
        </td>
        <td className="text col-sm-5">
          <span className="normal">
            {message.hasAttachment && <i className="material-icons attachment">attach_file</i>}
            {message.headers.subject}
          </span>
        </td>
        <td className="text col-sm-2">
          <span className="normal">{moment(message.headers.date).format(dateFormat)}</span>
        </td>
      </tr >
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    messageList: state.mail.messageList,
    selectedMessage: state.mail.selectedMessage,
    settings: state.settings.settings,
  };
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    checkUncheck: bindActionCreators(checkUncheckAction, dispatch),
    selectMessage: bindActionCreators(selectMessageAction, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MessageItem);



// WEBPACK FOOTER //
// ./src/components/mail/MessageItem.tsx